import React from 'react'

import { Stack } from 'primitives/containers'

import {
  FormattingBoldIcon,
  FormattingBulletIcon,
  FormattingItalicIcon,
  FormattingNumListIcon,
  FormattingQuoteIcon,
  FormattingSizeIcon,
} from '../../../../images'
import { ToolbarButton, ToolbarButtonProps } from './toolbar_button'

export type FormattingToolbarProps = Pick<
  ToolbarButtonProps,
  'desktop' | 'activeType'
>

export const FormattingToolbar = ({
  desktop = true,
  activeType,
}: FormattingToolbarProps) => {
  return (
    <Stack gap="1" direction="row">
      <ToolbarButton
        data-trix-attribute="bold"
        data-trix-key="b"
        title="Bold"
        tabIndex={-1}
        desktop={desktop}
        activeType={activeType}
      >
        <FormattingBoldIcon />
      </ToolbarButton>
      <ToolbarButton
        data-trix-attribute="italic"
        data-trix-key="i"
        title="Italic"
        tabIndex={-1}
        desktop={desktop}
        activeType={activeType}
      >
        <FormattingItalicIcon />
      </ToolbarButton>
      {/* Underline is not currently available - see https://github.com/basecamp/trix/issues/525 */}
      {/* <ToolbarButton
        data-trix-attribute="underline"
        data-trix-key="u"
        title="Underline"
        tabIndex={-1}
        desktop={desktop}
      >
        <FormattingUnderlineIcon />
      </ToolbarButton> */}
      <ToolbarButton
        data-trix-attribute="heading1"
        title="Heading"
        tabIndex={-1}
        desktop={desktop}
        activeType={activeType}
      >
        <FormattingSizeIcon />
      </ToolbarButton>
      <ToolbarButton
        data-trix-attribute="bullet"
        title="Bullets"
        tabIndex={-1}
        desktop={desktop}
        activeType={activeType}
      >
        <FormattingBulletIcon />
      </ToolbarButton>
      <ToolbarButton
        data-trix-attribute="number"
        title="Numbers"
        tabIndex={-1}
        desktop={desktop}
        activeType={activeType}
      >
        <FormattingNumListIcon />
      </ToolbarButton>
      <ToolbarButton
        data-trix-attribute="code"
        title="Code"
        tabIndex={-1}
        desktop={desktop}
        activeType={activeType}
      >
        <FormattingQuoteIcon />
      </ToolbarButton>
    </Stack>
  )
}
